import { render } from "./Examen.vue?vue&type=template&id=0c1df478&scoped=true"
import script from "./Examen.vue?vue&type=script&lang=js"
export * from "./Examen.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=0c1df478&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1df478"]])

export default __exports__